import type { EdgeStyle } from "../Graph.model";

const hiddenEdgeStyle: Partial<EdgeStyle> = {
  visible: false,
};

export default hiddenEdgeStyle;
